import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        admins: [],
    },
    // -----------------------------------------------------------------
    getters: {
        all: (state) => { return state.admins },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_ADMINS(state, admins) {
            state.admins = admins
        },
        SET_ADMIN(state, admin) {
            let index = state.admins.findIndex((a) => { a.id === admin.id })

            if (index !== -1) state.admins[index] = admin
        },
        ADD_ADMIN(state, admin) {
            state.admins.push(admin)
        },
        PUSH_ADMINS(state, admins) {
            state.admins = state.admins.concat(admins)
        }
    },
    // -----------------------------------------------------------------
    actions: {
        index: (context, data) => {
            return Vue.api.get('admins', { params: data })
                .then(response => {
                    context.commit((data.page === 1) ? 'SET_ADMINS' : 'PUSH_ADMINS', response.data.data)
                    return response.data;
                })
                .catch(error => { throw error.response.data.error })
        },
        read: (context, id) => {
            return Vue.api.get(`admins/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        create: (context, data) => {
            return Vue.api.post(`admins`, data)
                .then(response => {
                    context.commit('ADD_ADMIN', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        update: (context, data) => {
            return Vue.api.put(`admins/${data.id}`, data)
                .then(response => {
                    context.commit('SET_ADMINS', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        actionsIndex: (context, filter) => {
            return Vue.api.get('actions', { params: filter })
                .then(response => {
                    return response.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateActions: (context, action) => {
            return Vue.api.put(`actions/${action.id}`, action)
                .then(response => {
                    return response.data
                })
                .catch(error => { throw error.response.data.error })
        },
    }
}
